/*@ngInject*/
const DataSetEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, dataSetAction, dataSetActionsUtil, dataSetEditorModel, modalUtil) {

    // UMS-20495 workaround
    try {
        $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
    } catch (exception) {
        // do nothing
    }

    $element.addClass('dataSetEditorHeader');

    this.dataSet = null;
    this.translations = null;

    this.actions = [];
    this.context = {
        identifier: 'dataSetEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};

    this.$onInit = function () {
        localization.getTranslationByKey('dataSetEditorHeader').then((translations) => {
            this.dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);
            this.translations = translations;
            this.loadActions();
        });
    };

    this.loadActions = function () {
        configurationMediator.loadDataSetActionByName('com.firstbest.data.DataSet:' + $stateParams.dataSetName).then((actions) => {
            let allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });

            this.processActions(allActions, /*enableSaveAndDiscard*/false);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === dataSetAction.SAVE) {
                    action.enabled = false;
                    if (dataSetEditorModel.hasUnsavedChanges($stateParams.dataSetName)) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(this.translations, 'unsavedChanges')
                        };

                        if (dataSetEditorModel.isValidToSave($stateParams.dataSetName) &&
                            dataSetEditorModel.isValidDynamicCriterionToSave($stateParams.dataSetName) &&
                            dataSetEditorModel.isValidDependenciesToSave($stateParams.dataSetName)) {
                            action.enabled = true;
                        }
                    }
                }

                if (action.name === dataSetAction.DISCARD_CHANGES) {
                    action.enabled = false;
                    if (dataSetEditorModel.hasUnsavedChanges($stateParams.dataSetName)) {
                        action.enabled = true;
                    }
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    this.getType = function () {
        if (!_.isNil(this.dataSet)) {
            return _.get(this.translations, 'type.' + this.dataSet.type);
        }
        return '';
    };

    this.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
                case dataSetAction.SAVE:
                    dataSetActionsUtil.saveDataSet(this.dataSet);
                    break;

                case dataSetAction.DELETE:
                    dataSetActionsUtil.deleteDataSet(this.dataSet.name);
                    break;

                case dataSetAction.EXPORT:
                    dataSetActionsUtil.exportDataSet(this.dataSet.name);
                    break;

                case dataSetAction.DATA_SET_SETTINGS:
                    $uibModal.open({
                        templateUrl: '/configuration/dataSetSettings/dataSetSettingsTemplate.tpl.html',
                        controller: 'dataSetSettingsController',
                        windowClass: 'dataSetSettingsModal',
                        resolve: {
                            modalOptions: () => {
                                return {
                                    existingDataSetName: this.dataSet.name,
                                    dataSet: _.cloneDeep(this.dataSet)
                                };
                            }
                        }
                    });
                    break;

                case dataSetAction.NEW_DATA_SET:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;

                case dataSetAction.VIEW_REFERENCES:
                    dataSetActionsUtil.viewDataSetReferences(this.dataSet.name);
                    break;

                case dataSetAction.DISCARD_CHANGES:
                    dataSetActionsUtil.discardChanges();

                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, (event, dataSetName) => {
        if ($stateParams.dataSetName === dataSetName) {
            this.dataSet = dataSetEditorModel.getDataSet(dataSetName);
            this.processActions(this.actions);
        }
    });

    $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED, () => {
        this.processActions(this.actions);
    });

    $scope.$on(configurationConstant.event.DATA_SET_DYNAMIC_CRITERIA_UPDATED, () => {
        this.processActions(this.actions);
    });

    $scope.$on(configurationConstant.event.DATA_SET_DEPENDENCIES_UPDATED, () => {
        this.processActions(this.actions);
    });

    $scope.$on(coreConstant.event.RELOAD_ACTIONS, () => {
        this.loadActions();
    });

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        let isCurrentStateDataSetEditor = _.startsWith(fromState.name, 'configuration.dataSetEditor'),
            isTargetSameAsCurrent = toState.name === fromState.name,
            dataSetName = toParams.dataSetName ? toParams.dataSetName : $stateParams.dataSetName;
        if (toState.name === 'login') {
            return;
        }

        if (dataSetEditorModel.hasUnsavedChanges(dataSetName) && isCurrentStateDataSetEditor && !isTargetSameAsCurrent) {
            event.preventDefault();
            if (dataSetEditorModel.isValidToSave(dataSetName)) {
                dataSetActionsUtil.saveDataSet(this.dataSet).then(function () {
                    $state.go(toState, toParams);
                });
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidDataSet'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    });
};

angular.module('ums.configuration')
    .controller('dataSetEditorHeaderController', DataSetEditorHeaderController);
